const patientsManagementTableSearchableFields = [
  'first_name',
  'last_name',
  'tipo_documento_id',
  'id_document',
  'email',
  'contact_phone_number',
  'patient_status',
  'aseguradora',
  'centro',
  'modalidad'
];

const patientstatusFilters = [
  {
    text: 'Activo',
    value: 'Activo'
  },
  {
    text: 'Inactivo',
    value: 'Inactivo'
  },
  {
    text: 'Invitado',
    value: 'Invitado'
  },
  {
    text: 'Pendiente',
    value: 'Pendiente'
  }
];

module.exports = {
  patientsManagementTableSearchableFields,
  patientstatusFilters
};
